import _ from 'lodash';

export function convertSellingUnitQuantity(sellingUnitQuantity: number, product: any, unit: string, sellingUnit?: string): number {
  const packingMode: { quantity: number, unit1: string, unit2: string }[] = _.get(product, 'packingMode', []);
  const resolvedSellingUnit = sellingUnit || _.get(product,'unit.unit2','').toLowerCase();
  if(unit == resolvedSellingUnit) return sellingUnitQuantity;
  let quantityMultiplier = 1;
  if(_.get(packingMode, '0.unit1') == resolvedSellingUnit) {
    if(_.get(packingMode, '0.unit2') == unit) {
      quantityMultiplier = quantityMultiplier / _.get(packingMode, '0.quantity', 1);
    }
    if(_.get(packingMode, '1.unit2') == unit) {
      quantityMultiplier = quantityMultiplier / (_.get(packingMode, '0.quantity', 1) * _.get(packingMode, '1.quantity', 1));
    }
  } else if(_.get(packingMode, '0.unit2') == resolvedSellingUnit) {
    if(_.get(packingMode, '0.unit1') == unit) {
      quantityMultiplier = quantityMultiplier * _.get(packingMode, '0.quantity', 1);
    }
    if(_.get(packingMode, '1.unit2') == unit) {
      quantityMultiplier = quantityMultiplier / _.get(packingMode, '1.quantity', 1);
    }
  } else {
    if(_.get(packingMode, '0.unit2') == unit) {
      quantityMultiplier = quantityMultiplier * _.get(packingMode, '1.quantity', 1);
    }
    if(_.get(packingMode, '0.unit1') == unit) {
      quantityMultiplier = quantityMultiplier * _.get(packingMode, '0.quantity', 1)  * _.get(packingMode, '1.quantity', 1);
    }
  }
  return _.round(sellingUnitQuantity * quantityMultiplier, 2);
}